import { PackageConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-date-picker";
import { TRAVELERS_HIDDEN_INPUT_TYPE } from "src/components/shared/TravelersField";

const travelersConfig = {
  icon: "person",
  labelToken: "wizard.roomPicker.travelers.title",
  dialogTitleToken: "wizard.roomPicker.travelers.title",
  dialogCancelLabelToken: "wizard.roomPicker.closeButton.a11yLabel",
  childrenCaptionToken: "wizard.roomPicker.children.withInfants.caption",
  infantsCaptionToken: "wizard.roomPicker.infants.caption",
  youngestChildAgeTextToken: "",
  youngestInfantAgeTextToken: "wizard.roomPicker.youngestChildAge.text",
  invalidLessThanNTravelersMessageToken: "wizard.travelers.warning.invalidNumberOfTravelers.text",
  invalidUnattendedInfantOnLapMessageToken: "wizard.travelers.warning.unattendedInfantOnLap.text",
  minBookableTravelers: 1,
  maxBookableTravelers: 6,
  minChildAge: 2,
  maxChildAge: 17,
  minInfantAge: 0,
  maxInfantAge: 1,
  minAdultsPerRoom: 1,
  maxAdultsPerRoom: 6,
  minChildrenPerRoom: 0,
  maxChildrenPerRoom: 6,
  minInfantsPerRoom: 0,
  maxInfantsPerRoom: 6,
  maxRooms: 6,
  withRooms: true,
  withFlight: true,
  withInfants: true,
  hiddenInputType: TRAVELERS_HIDDEN_INPUT_TYPE.PACKAGE_SEARCH
};

export const packageConfig: PackageConfig = {
  navigation: {
    tabIcon: "lob_packages",
    tabTitleToken: "wizard.package.FlightHotel.label"
  },
  lastSearch: {
    useLastSearchForSingleLOB: false,
    lastSearchKey: "lastSearchCookie",
    lobKey: "wizard-package-pwa"
  },
  location: {
    origin: {
      inputName: "origin",
      icon: "place",
      invalidLocationMessageKey: "wizard.origin.warning.invalidOrigin.text",
      labelToken: "wizard.package.flight.origin.label",
      typeaheadLabelToken: "wizard.package.flight.origin.placeholder",
      pwaDialogQueryParam: "origin-package",
      essAdapterConfig: {
        lob: "PACKAGES",
        client: "HotelsLandingPage",
        features: "ta_hierarchy|postal_code|contextual_ta|google",
        maxResults: 7,
        regionType: 2047
      }
    },
    destination: {
      inputName: "destination",
      icon: "place",
      invalidLocationMessageKey: "wizard.destination.warning.invalidDestination.text",
      invalidOriginSameAsDestinationKey: "wizard.destination.warning.originDifferentFromDestination.text",
      labelToken: "wizard.package.flight.destination.label",
      typeaheadLabelToken: "wizard.package.flight.destination.placeholder",
      pwaDialogQueryParam: "destination-package",
      essAdapterConfig: {
        lob: "PACKAGES",
        client: "HotelsLandingPage",
        features: "ta_hierarchy|postal_code|contextual_ta|google",
        maxResults: 7,
        regionType: 2047
      }
    }
  },
  hotelDestination: {
    inputName: "hotelDestination",
    icon: "place",
    invalidLocationMessageKey: "wizard.destination.warning.invalidDestination.text",
    invalidOriginSameAsDestinationKey: "wizard.destination.warning.originDifferentFromDestination.text",
    labelToken: "wizard.package.flight.destination.label",
    pwaDialogQueryParam: "hotel-destination",
    essAdapterConfig: {
      lob: "HOTELS",
      client: "HotelsLandingPage",
      features: "contextual_ta|postal_code|uta_client|google|multiregion_parent|ta_hierarchy|consistent_display",
      maxResults: 7,
      regionType: 991
    }
  },
  date: {
    ISOSubmissionSupport: true,
    format: "yyyy-MM-dd",
    submissionFormat: "yyyy-MM-dd",
    firstDayOfWeek: DayName.SUN,
    daysBookableInAdvance: 500,
    maxDaysRange: 26,
    invalidStartDateMessageToken: "wizard.datePicker.warning.invalidDepartingDate.text",
    invalidEndDateMessageToken: "wizard.datePicker.warning.invalidReturningDate.text",
    invalidMaxDatesRangeMessageToken: "wizard.datePicker.warning.maxDatesRange.text",
    invalidStartDateOutOfRangeMessageToken: "",
    invalidEndDateOutOfRangeMessageToken: "",
    midnightBookingOffset: 4,
    start: {
      labelToken: "wizard.departing.label"
    },
    end: {
      labelToken: "wizard.returning.label"
    },
    queryParam: {
      start: "fromDate",
      end: "toDate"
    },
    dialogId: "departing-returning"
  },
  partialStayDate: {
    ISOSubmissionSupport: true,
    format: "yyyy-MM-dd",
    submissionFormat: "yyyy-MM-dd",
    firstDayOfWeek: DayName.SUN,
    daysBookableInAdvance: 500,
    midnightBookingOffset: 4,
    maxDaysRange: 26,
    invalidStartDateMessageToken: "wizard.datePicker.warning.invalidFromDate.text",
    invalidEndDateMessageToken: "wizard.datePicker.warning.invalidToDate.text",
    invalidMaxDatesRangeMessageToken: "wizard.datePicker.warning.maxDatesRange.text",
    invalidStartDateOutOfRangeMessageToken: "wizard.datePicker.warning.checkInDateOutOfRange.text",
    invalidEndDateOutOfRangeMessageToken: "wizard.datePicker.warning.checkOutDateOutOfRange.text",
    start: {
      labelToken: "datePicker.fromDate.label"
    },
    end: {
      labelToken: "datePicker.toDate.label"
    },
    queryParam: {
      start: "checkInDate",
      end: "checkOutDate"
    },
    dialogId: "partial-stay-check-in-out"
  },
  travelers: travelersConfig,
  subLOB: {
    flightCar: {
      travelers: {
        ...travelersConfig,
        withRooms: false,
        withFlight: true,
        withInfants: true
      }
    },
    hotelCar: {
      date: {
        ISOSubmissionSupport: true,
        format: "yyyy-MM-dd",
        submissionFormat: "yyyy-MM-dd",
        firstDayOfWeek: DayName.SUN,
        daysBookableInAdvance: 500,
        midnightBookingOffset: 4,
        maxDaysRange: 26,
        invalidStartDateMessageToken: "wizard.datePicker.warning.invalidFromDate.text",
        invalidEndDateMessageToken: "wizard.datePicker.warning.invalidToDate.text",
        invalidMaxDatesRangeMessageToken: "wizard.datePicker.warning.maxDatesRange.text",
        invalidStartDateOutOfRangeMessageToken: "",
        invalidEndDateOutOfRangeMessageToken: "",
        start: {
          labelToken: "datePicker.fromDate.label"
        },
        end: {
          labelToken: "datePicker.toDate.label"
        },
        queryParam: {
          start: "fromDate",
          end: "toDate"
        },
        dialogId: "departing-returning"
      },
      travelers: {
        ...travelersConfig,
        withRooms: true,
        withFlight: false,
        withInfants: true
      }
    }
  },
  form: {
    action: "/flexibleshopping",
    submitButton: {
      locToken: "wizard.submit.label"
    }
  },
  heading: {
    fixedTitle: false,
    lobSubtitleBreakPoint: "on",
    locToken: "wizard.mobile.label.package"
  },
  showAllSubLOB: true,
  elementId: "wizard-package-pwa"
};
